export default __webpack_public_path__ + "static/media/custom_pen.a52ac1b1.png";